import { CornerDownLeft } from 'lucide-react';
import KeyboardShortcut from './KeyboardShortcut';
import { formatKeyboardShortcut } from '../utils/keyboard-shortcut';

export function Alt1(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+1" className={props.className} />;
}

export function Alt2(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+2" className={props.className} />;
}

export function Alt3(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+3" className={props.className} />;
}

export function AltN(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+N" className={props.className} />;
}

export function AltT(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+T" className={props.className} />;
}

export function AltI(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+I" className={props.className} />;
}

export function AltS(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+S" className={props.className} />;
}

export function AltE(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+E" className={props.className} />;
}

export function AltV(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+V" className={props.className} />;
}

export function AltB(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+B" className={props.className} />;
}

export function AltG(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+G" className={props.className} />;
}

export function AltC(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+C" className={props.className} />;
}

export function AltA(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+A" className={props.className} />;
}

export function AltP(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+P" className={props.className} />;
}

export function AltShiftA(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+Shift+A" className={props.className} />;
}

export function AltShiftD(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+Shift+D" className={props.className} />;
}

export function AltD(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+D" className={props.className} />;
}

export function AltZ(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+Z" className={props.className} />;
}

export function AltR(props: { className?: string }) {
  return <KeyboardShortcut shortcut="Alt+R" className={props.className} />;
}

export function Esc(props: { className?: string }) {
  return <KeyboardShortcut shortcut="ESC" className={props.className} />;
}

export function Enter(props: { className?: string }) {
  return (
    <KeyboardShortcut
      shortcut="Enter"
      icon={<CornerDownLeft className="h-2.5 w-2.5" />}
      className={props.className}
    />
  );
}

export function AltEnter(props: { className?: string }) {
  return (
    <KeyboardShortcut
      shortcut="Alt+Enter"
      icon={
        <span className="flex items-center">
          {formatKeyboardShortcut('Alt')}
          <span>+</span>
          <CornerDownLeft className="h-2.5 w-2.5" />
        </span>
      }
      className={props.className}
    />
  );
}
